/** 退会申請中 */
export const FAMILY_CUSTOMER_STATUS_QUIT_APPLICATION_SUBMITTED = "7f5741b7-71d6-451b-8446-0cd53473a360";
